import React from 'react'
import { Row, Col, Typography, Card, Space } from 'antd'
import './About.scss'

// 引入设计稿相关图片（需自行替换为实际图片，放在src/assets/images/about/下）
import aboutBanner from '../../assets/images/banner-1.jpg' // ABOUT US 顶部banner图
import companyBuilding from '../../assets/images/about_tu.jpg' // 公司建筑图
import icon1 from '../../assets/images/p_icon01a.png' // 核心价值图标1
import icon2 from '../../assets/images/p_icon02a.png' // 核心价值图标2
import icon3 from '../../assets/images/p_icon03a.png' // 核心价值图标3
import icon4 from '../../assets/images/p_icon04a.png' // 核心价值图标4

const { Title, Paragraph, Text } = Typography

const About = () => {
  // Sense Worth 核心价值数据（匹配设计稿）
  const senseWorthList = [
    {
      title: 'Our Vision',
      desc: 'Adhering to the philosophy of "putting people first, guided by technology, and pursuing survival through quality", we strive for the sustainable development of the enterprise and create value for our clients',
      icon: icon1 // 可替换为Antd图标，如EyeOutlined
    },
    {
      title: 'Customer-centric',
      desc: 'We are customer-centric, striving to understand their core needs and serving them by exceeding their expectations',
      icon: icon2 // 可替换为Antd图标，如UserOutlined
    },
    {
      title: 'Continuous innovation',
      desc: 'We are constantly innovating and advancing our technological and service levels, aiming not to be fully meet their demands',
      icon: icon3 // 可替换为Antd图标，如SyncOutlined
    },
    {
      title: 'Continuously improving services',
      desc: 'We are committed to continuously improving our professional and standardized customer experience through services',
      icon: icon4 // 可替换为Antd图标，如LineChartOutlined
    }
  ]

  return (
    <div className='about-page'>
      {/* 1. About Us Banner 区域 */}
      <section className='about-banner'>
        <div className='banner-bg' style={{ backgroundImage: `url(${aboutBanner})` }}>
          <div className='banner-overlay'>
            <div className='banner-inner'>
              <Title level={2} className='banner-title'>
                ABOUT US
              </Title>
            </div>
          </div>
        </div>
      </section>

      {/* 2. 公司介绍区域 */}
      <section className='company-intro section'>
        <div className='section-inner'>
          <Row gutter={[30, 20]} align='center'>
            {/* 左侧建筑图片：移动端占满行，桌面端占12列 */}
            <Col xs={24} md={12}>
              <img src={companyBuilding} alt='L AND P Building' className='building-img' width='100%' />
            </Col>
            {/* 右侧公司介绍文字：移动端占满行，桌面端占12列 */}
            <Col xs={24} md={12}>
              <Title level={3} className='section-title about-subtitle'>
                ABOUT US Hangkong L AND P TRADE LIMITED.
              </Title>
              <Paragraph className='intro-text'>
                Because of your focus, now here is a professional team. Everything is by your side when you need it.
                In!!
              </Paragraph>
              <Paragraph className='intro-text'>
                L AND P TRADE LIMITED. We specialize in the imported chemicals in the Chinese market and the export of
                domestic chemicals.
              </Paragraph>
              <Paragraph className='intro-text'>
                Our products include organic and inorganic chemicals, functional chemicals, intermediates, special and
                custom chemicals, and new materials, covering a wide range of industries, such as pharmaceuticals,
                agrochemicals, dyes, flavors and fragrances, daily chemicals, lubricants, electronics, solar energy,
                industry and construction.
              </Paragraph>
              <Paragraph className='intro-text'>
                The company has long-term stable and close cooperation with many well-known chemical companies around
                the world, and is the exclusive agent of Shell, Chevron, ExxonMobil, Idemitsu and many other well-known
                foreign chemical companies in the Chinese market. We are committed to introducing high-quality raw
                materials from well-known Chinese chemical companies into the international chemical market, improving
                the production efficiency and product quality of related industries, and enhancing the competitiveness
                of related products in the domestic and international markets.
              </Paragraph>
              <Paragraph className='intro-text'>
                "Integrity service, positive development" is our business purpose, "grow together with customers and
                achieve win-win results" is our goal.
              </Paragraph>
            </Col>
          </Row>
        </div>
      </section>

      {/* 3. Sense Worth 核心价值区域 */}
      <section className='sense-worth-section'>
        <div className='section-inner'>
          <Title level={3} className='section-title worth-title'>
            Sense Worth
          </Title>
          <Row gutter={[20, 20]}>
            {senseWorthList.map((item, index) => (
              <Col
                key={index}
                xs={24} // 移动端1列
                sm={12} // 平板2列
                md={6} // 桌面4列
                className='worth-item-col'
              >
                <Card className='worth-card'>
                  <Space direction='vertical' size='middle' className='worth-card-content'>
                    <img src={item.icon} alt={item.title} className='worth-icon' width={40} height={40} />
                    <Title level={4} className='worth-title-text'>
                      {item.title}
                    </Title>
                    <Paragraph className='worth-desc'>{item.desc}</Paragraph>
                  </Space>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </section>
    </div>
  )
}

export default About
